import { Button } from "src/components";
import styled from "styled-components";

export const QuestionContainer = styled.div`
  display: flex;
  max-width: 315px;
  padding: 8px;
  align-items: center;
  gap: 16px;
  border-radius: 4px;
  border: 1px solid
    ${(props) =>
    props.selected
      ? props.theme.colors.secondary
      : props.theme.colors.disabledMeatballItem};
  background: ${(props) =>
    props.selected
      ? props.theme.colors.EvolutivevOkButtonColor
      : 'transparent'};
  width: 100%;
  cursor: pointer;
`;

export const QuestionTitle = styled.h4`
  color: ${(props) => props.theme.colors.constrat};
  font-size: ${(props) => (props.isQuestion ? "10px" : "12px")};
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const CheckboxButton = styled(Button)`
  cursor: pointer;
  height: 20px;
  width: 20px;
  background-color: transparent;
  padding: 2px 0;

  &:hover {
    background-color: transparent;
    color: transparent;
  }
`;

export const Square = styled.span`
  width: 16px;
  height: 16px;
  border-radius: 2.28571px;
  border: 1px solid
    ${(props) =>
    props.isChecked
      ? props.theme.colors.secondary
      : props.theme.colors.text.default};
  display: inline-block;
  background: ${(props) =>
    props.isChecked
      ? props.theme.colors.secondary
      : 'transparent'};
  box-sizing: border-box;
  position: relative;

  ${(props) =>
    props.isChecked
      ? `
    :before,
  :after {
    content: "";
    position: absolute;
    display: block;
    height: 9px;
    width: 1.6px;
    background: ${props.theme.colors.backgroundColorPage};
  }

  :after {
    transform: rotate(45deg);
    left: 8px;
    top: 3px;
  }
  :before {
    height: 6px;
    transform: rotate(-45deg);
    left: 4px;
    top: 5px;
  }
  `
      : ""}
`;